import React, { useState, useEffect, useMemo } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import useWindowDimensions from 'customHook/useWindowDimensions'
import Spinner from 'components/Spinner';
import EighthFloor from '../FloorPlan/EighthFloor'
import NinthFloor from '../FloorPlan/NinthFloor'
import TenthFloor from '../FloorPlan/TenthFloor'
import Legend from '../Legend'
import ModalRoomChange from "screens/ModalRoomChange";
import { useQuery } from '@apollo/client';
import { GET_AVAILABLE_ROOMS_FOR_ROOM_CHANGE } from 'graphql/service';
import ActiveMapLegend from 'assets/icons/activeMapLegend.svg'
import MapLegend from 'assets/icons/mapLegend.svg'
import { Container, Header, ViewLegend, MapRow } from './style';
import colors from 'constants/colors'
import { debouncedErrorMessage } from 'utils/messageUtil'

const ManageRooms = () => {

  const navigate = useNavigate()
  const { width } =useWindowDimensions()
  const scale = width/1440 * 1.35
  const bookingId = useParams().bookingId;
  const [isLegendVisible, setIsLegendVisible] = useState(false)

  const {
    loading,
    data: availableRoomsData,
    error,
  } = useQuery(GET_AVAILABLE_ROOMS_FOR_ROOM_CHANGE, {
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    variables: { 
      input: {
        bookingId: bookingId
      }
    }
  })

  const { eighthFloorRooms, ninthFloorRooms, tenthFloorRooms } = useMemo(() => {
    const result = {
      eighthFloorRooms: {},
      ninthFloorRooms: {},
      tenthFloorRooms: {},
    };

    if (!availableRoomsData?.availableRoomsForRoomChange) return result;

    availableRoomsData.availableRoomsForRoomChange.forEach(room => {
      switch (room.floor) {
        case '8':
          result.eighthFloorRooms[room.roomNumber] = room;
          break;
        case '9':
          result.ninthFloorRooms[room.roomNumber] = room;
          break;
        case '10':
          result.tenthFloorRooms[room.roomNumber] = room;
          break;
        default:
          break;
      }
    });

    return result;
  }, [availableRoomsData]);

  useEffect(() => {
    if (!error) return;

    if (!error.networkError) {
      let content = error.message;

      if (error.message.includes('Validation')) {
        content = JSON.stringify(
          error.graphQLErrors[0]?.extensions?.exception
        );
      }

      debouncedErrorMessage(content);
    }
  }, [error]);
    
  if (loading) return <Spinner />;

  return (
    <Container>
      <Header>
        <ViewLegend
          onClick={() => setIsLegendVisible(!isLegendVisible)}
          active={isLegendVisible}
        >
          {isLegendVisible ?
            <img src={ActiveMapLegend} alt={'activeMapLegend'} /> :
            <img src={MapLegend} alt={'mapLegend'} />}
          <div>{isLegendVisible ? 'HIDE LEGEND' : 'VIEW LEGEND'}</div>
        </ViewLegend>
      </Header>
      <MapRow scale={scale}>
        <div className='floor'>
          <div
            className='floorNumber'
            onClick={()=>navigate('/floor/8')}
          >
            <span className='infoType'>FLOOR</span>
            <span className='number'>8</span>
          </div>
          <EighthFloor scale={scale} backgroundColor={colors.black1} rooms={eighthFloorRooms}/>
        </div>
        <div className='floor'>
          <div
            className='floorNumber'
            onClick={()=>navigate('/floor/9')}
          >
            <span className='infoType'>FLOOR</span>
            <span className='number'>9</span>
          </div>
          <NinthFloor scale={scale} backgroundColor={colors.black1} rooms={ninthFloorRooms}/>
        </div>
        <div className='floor'>
          <div
            className='floorNumber'
            onClick={()=>navigate('/floor/10')}
          >
            <span className='infoType'>FLOOR</span>
            <span className='number'>10</span>
          </div>
          <TenthFloor scale={scale} backgroundColor={colors.black1} rooms={tenthFloorRooms}/>
        </div>
      </MapRow>
      { isLegendVisible? <Legend desktop/> : null}
      <ModalRoomChange />
    </Container>
  );
};

export default ManageRooms;
